<template>
  <div>
    <v-cal-tbl-map
      :reload="reload"
      :eventClick="eventClick"
      :eventTemplate="eventTemplate"
      :onDataReceived="onDataReceived"
      :noDelete="true"
      ref="calTblMap"
      :linkClick="linkClick"
      :link="link"
      :mapTitle="mapTitle"
      :mapReady="mapReady"
      :mapData="mapData"
      :mapHeight="mapHeight"
      :mapWidth="mapWidth"
      :mapLegend="mapLegend"
      :editable="editable"
      :onMarkerClick="onMarkerClick"
      :dateField="dateField"
      :getDataObject="getDataObject"
      :defaultEventColor="defaultEventColor"
      :updateTable="updateTable"
      :calToolBarControls="calToolBarControls"
      defaultType="month"
    >
    </v-cal-tbl-map>
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import axios from "axios";
import TakePhoto from "../components/TakePhoto.vue";

export default {
  name: "OnsiteEstimates",
  components: {
    VCalTblMap: () => import("../components/CalTblMap.vue"),
  },
  props: {},
  data() {
    return {
      dateField: "estimate_date",
      mapTitle: "Estimate Map",
      defaultEventColor: "#137C15FF",
      // data_object: null,

      link: {
        field: "shipment_id",
        name: "shipment",
      },
      mapReady: false,
      mapData: [],
      curEst: {},
      init: false,
      estCombo: {
        label: "Select Estimator",
        objName: "v_estimator",
        ctlName: "estCombo",
        itemText: "full_name",
        itemValue: "_id",
        defaultIndex: -1,

        returnObject: true,
      },
      mapLegend: {
        data_object: {
          object_name: "v_estimator",
          get_table: "all",
        },
        getFreshData: true,
        mobileBreakpoint: 0,
        all_records: true,
        table_title: "Estimator",
        tableName: "estimator",
        hasSearch: true,
        fields_included: ["employee_id", "full_name"],
        noTabs: true,
        hideHeader: true,
        singleSelect: true,
        coloredFields: ["employee_id"],

        getItemColor: function(e, slot, item, tableName) {
          return item.color;
        },
        width: 3,
      },
      editable: ["estimator"],
      d: null,
    };
  },
  mounted() {
    this.init = true;
    var that = this;

    this.getDataObject();
    if (this.checkPermissions()) {
      this.mapLegend = { width: 0 };
    }

    this.calToolBarControls = [
      {
        comp: "v-combo",
        id: "curEst",

        model: this.curEst,
        "v-bind": this.estCombo,
      },
    ];
    this.$root.$on("comboUpdated", (c) => {
      // console.log(c);
      if (!that.init) {
        if (c.ctlName == "estCombo") {
          that.curEst = c.model;
          that.updateEst();

          // this.objKey = !this.objKey;
        }
      }
      that.init = false;
    });
  },
  beforeDestroy() {},
  methods: {
    updateEst() {
      var that = this;
      var cal = this.$refs.calTblMap.$refs.calendar;
      if (cal) {
        cal.events = cal.originalEvents.filter((r) => {
          return (
            !that.curEst ||
            (that.curEst && r.estimator && r.estimator._id == that.curEst._id)
          );
        });
        cal.calKey = !cal.calKey;
      }
    },
    updateTable(t, f) {
      var data = {
        collection: "shipment",
        qry: {
          _id: t.item._id,
          onsite_estimate: {
            $elemMatch: { _id: t.item.estimate_id },
          },
        },
        update: {
          "onsite_estimate.$.estimator": t.item.estimator,
        },
      };
      axios
        .post(this.serverURL + "/modify_value", data, {
          withCredentials: true,
        })
        .then((r) => {
          // this.$refs.calTblMap.refresh(this.d);
          if (f) {
            f(r);
          }
        });
    },
    linkClick: function(item) {
      this.$root.addResentTab(item);
    },

    eventTemplate: function(e, data, obj) {
      var endTime = new Date(e.estimate_date).addHours(1);
      var ev = {
        name:
          e.shipment_id +
          " " +
          e.customer.contact.first_name +
          " " +
          e.customer.contact.last_name,
        start: e.estimate_date,
        end: endTime,
        shipment_id: e.shipment_id,
        first_name: e.customer.contact.first_name,
        last_name: e.customer.contact.last_name,
        estimator: e.estimator,
        color: e.estimator ? e.estimator.color : "",
        // end: fun.formatDateTime(endTime),
        timed: true,
      };

      return ev;
    },
    reload() {
      //
    },
    getDataObject() {
      var data_object = {
        object_name: "v_onsite_estimate",
        date_fields: ["estimate_date"],
        mobileBreakpoint: 0,
        table_title: "Onsite Estimates",

        hasSearch: true,
      };
      if (this.checkPermissions()) {
        data_object.id_fields = ["estimator_id"];
        data_object.qry = { estimator_id: this.$root.user_id };
      }
      if (this.$root.filteredCompanies()) {
        if (!data_object.id_fields) {
          data_object.id_fields = [];
        }
        // data_object.id_fields.push("_id");
        // var list_of_company_ids = this.$root.store.userData.company.map(
        //   (c) => c._id["$oid"]
        // );
      }
      return data_object;
    },

    onMarkerClick(data, e) {
      var that = this;
      var topElement = e.target
        .closest(".map-outer")
        .getElementsByClassName("map-top")[0];
      var innerElement = e.target
        .closest(".map-outer")
        .getElementsByClassName("map-inner")[0];

      var unassign = false;
      var msg = "";

      if (topElement.innerHTML == data.legend.selected[0].employee_id) {
        unassign = true;
      }
      msg =
        "Confirm assigning " +
        data.legend.selected[0].full_name +
        " to #" +
        data.shipment_id +
        "?";

      if (unassign) {
        msg = "Confirm unassigning #" + data.shipment_id + "?";
      }

      // this.$root.$confirm
      //   .open("Confirmation", msg, {
      //     color: "green",
      //   })
      //   .then((confirm) => {
      //     if (confirm) {
      data.item.estimator = data.legend.selected[0];
      data.item.estimator_id = data.legend.selected[0]._id;
      data.item.estimator_name = data.legend.selected[0].full_name;
      this.updateTable(data, (resp) => {
        innerElement.style.backgroundColor = data.legend.selected[0].color;
        that.mapData.filter((m) => {
          return m.item._id == data.item._id;
        })[0].item.estimator = data.item.estimator;
        this.$refs.calTblMap.refresh(data);
        // this.$refs.calTblMap.tableData.filter((e) => {
        //   return e._id == data.item._id;
        // })[0].estimator = data.item.estimator;
        // this.$refs.calTblMap.refreshTable();

        // this.$root.$emit("dataChanged", {
        //   data: this.$refs.calTblMap.tableData,
        //   tableTitle: that.tableName,
        // });
      });
      // }
      // });
    },
    eventClick(e) {
      this.linkClick(e.event);
    },
    checkPermissions() {
      this.currentUser = this.$root.store.userData.email;
      var permittedActions = this.$root.store.permittedActions;
      var filterJobs = false;

      if (permittedActions) {
        permittedActions.forEach((a) => {
          if (a.filter_jobs && !this.$root.isAdmin) {
            filterJobs = true;
            // .sales_person_email = this.currentUser;
          }
        });
      }
      return filterJobs;
    },
    onDataReceived(data, d) {
      console.log(data);
      this.mapData = [];
      this.mapReady = false;
      var filteredCompanies = this.$root.filteredCompanies();
      if (filteredCompanies) {
        data.model = data.model.filter((r) => {
          return filteredCompanies.includes(r.company._id);
        });
      }

      if (d) {
        this.d = d;
        var serviceDate = fun.getFullDate(d);
        var curModel = data.model.filter((m) => {
          return fun.getFullDate(new Date(m.estimate_date)) == serviceDate;
        });
        curModel.forEach((e) => {
          e.first_name = e.customer.contact.first_name;
          e.last_name = e.customer.contact.last_name;
          var customer_name = e.first_name + " " + e.last_name;
          e.estimate_date = fun.formatDate(e.estimate_date, false, true);

          e.customer.address.forEach((a) => {
            if (
              e.estimate_address &&
              a.location.address.address == e.estimate_address
            ) {
              var position = a.location.address.geo.location.position;
              var pos = {
                lat: position[0],
                lng: position[1],
              };

              this.mapData.push({
                pos: pos,
                shipment_id: e.shipment_id,
                item: e,
                label:
                  customer_name + " " + e.estimate_date + " #" + e.shipment_id,
                address: e.estimate_address,
                shortLabel: fun.formatTime(e.estimate_date, true),
                // shortLabel: '<div class="mdi mdi-home"></div>',
                markerColor: e.estimator ? e.estimator.color : "",
              });
            }
          });
        });
        this.$root.$emit("mapDataChanged", {
          data: this.mapData,
          legend: this.mapLegend,
        });
        this.mapReady = true;
        return data.table;
      } else {
        data.events = [];
        data.model.forEach((m) => {
          data.events.push(this.eventTemplate(m));
        });
        return data;
      }
    },
  },
};
</script>

<style lang="css" scoped></style>
